import React from "react";
import "./landingFooter.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useNavigate } from "react-router-dom";

function LandingFooter() {
  const navigate = useNavigate();

  return (
    <footer className="landing-footer">
      <div className="container d-flex justify-content-between align-items-start">
        <div className="landing-footer-left-container">
          <span className="landing-footer-left">Speqqle SA</span>
          <span>&copy; Speqqle SA 2025</span>
          <a
            href="#"
            className="linkedin-icon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
        </div>
        <div className="landing-footer-container">
          <div className="landing-footer-column">
            <h5>app.speqqle</h5>
            <p
              className="clikable"
              onClick={() => navigate("/functions-landing")}
            >
              Functions
            </p>
            <p
              className="clikable"
              onClick={() => navigate("/applications-landing")}
            >
              Applications
            </p>
            <p className="clikable" onClick={() => navigate("/prices-landing")}>
              Prices
            </p>
            <p className="clikable" onClick={() => navigate("/login")}>
              Login
            </p>
            <a
              href="https://speqqle.ch/contact-us/"
              style={{ textDecoration: "none", color: "white" }}
            >
              <p className="clikable">Contact us</p>
            </a>
          </div>
          <div className="landing-footer-column">
            <h5>company</h5>
            <a
              href="https://speqqle.ch"
              style={{ textDecoration: "none", color: "white" }}
            >
              <p className="clikable">Speqqle SA</p>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default LandingFooter;
